/**
 * The date windows the dashboard offers.
 *
 * "All time" is the default rather than a trailing week: transition logging is
 * populated forward only, so a project's whole history is usually days long and
 * a 7-day default would silently hide most of it.
 */
export interface DateWindow {
    key: string;
    label: string;
    days: number | null;
}

export const WINDOWS: DateWindow[] = [
    { key: '7d', label: 'Last 7 days', days: 7 },
    { key: '30d', label: 'Last 30 days', days: 30 },
    { key: '90d', label: 'Last 90 days', days: 90 },
    { key: 'all', label: 'All time', days: null }
];

export const windowSince = (key: string): string | undefined => {
    const window = WINDOWS.find((w) => w.key === key);
    if (!window || window.days === null) return undefined;
    const since = new Date();
    since.setDate(since.getDate() - window.days);
    return since.toISOString();
};

export const windowLabel = (key: string): string =>
    WINDOWS.find((w) => w.key === key)?.label ?? 'All time';
